<template>
    <div class="app-container">
        <el-card shadow="never">
            <el-row>
                <el-col :span="16">
                    <el-radio-group @change="changeCativeType" v-model="cativeType" size="mini">
                        <el-radio-button label="课题引领" />
                        <el-radio-button label="教研赛事" />
                        <el-radio-button label="专题活动" />
                    </el-radio-group>
                </el-col>
            </el-row>
            <topic v-if="cativeType == '课题引领' || cativeType == '教研赛事' || cativeType == '专题活动'" ref="topic"></topic>
        </el-card>
    </div>
</template>

<script>
import { timestampToTime } from "@/utils/date";
import listeningEvaluat from "./listeningEvaluat.vue";
import cooperate from "./cooperate.vue";
import topic from "./topic.vue";

export default {
    name: "ptStatistics",
    components: {
        listeningEvaluat,
        topic
    },
    data() {
        return {
            cativeType: '课题引领',
            timestampToTime,

        };
    },
    created() {
    },
    mounted() {
    },
    activated() {
        // console.log('fdssfd',this.$route.query.isSx)
        if (this.$route.query.isSx == 1) {

        }
    },
    watch: {
        $route(to, from) {
            console.log('to', to)
        },
    },
    methods: {
        changeCativeType() {
            if (this.cativeType == '课题引领' || this.cativeType == '教研赛事' || this.cativeType == '专题活动') {
                this.$refs.topic.changeCativeType(this.cativeType)
            }
        },
    }
};
</script>
<style scoped>
/deep/ .el-input-group__append {
    background: var(--el-color-primary);
    color: #fff;
}

.csbbb {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
}

.zdp /deep/ .el-range-editor.el-input__wrapper {
    width: 100%;
}
</style>